/** DB administrator (app_roles.admin), mirrored from login response for UI gating. */
export const AUTH_ADMIN_KEY = "projectBoardAuthUserAdmin";

export function readStoredAdminFlag() {
  try {
    return localStorage.getItem(AUTH_ADMIN_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeStoredAdminFlag(isAdmin) {
  try {
    if (isAdmin) localStorage.setItem(AUTH_ADMIN_KEY, "1");
    else localStorage.removeItem(AUTH_ADMIN_KEY);
  } catch {
    /* ignore */
  }
}
